// 权限管理路由
const general: any = [
    {
        path: 'product/list',
        name: 'product_list',
        meta: {
            pathTitle: 'product_list',
            title: '产品列表'
        },
        component: () => import('@/views/product/list.vue')
    },
    // {
    //     path: 'product/productDetail',
    //     name: 'productDetail',
    //     meta: {
    //         pathTitle: 'product_list',
    //         title: '产品详情'
    //     },
    //     component: () => import('@/views/product/productDetail.vue')
    // },
    {
        path: 'product/productConfig',
        name: 'productConfig',
        meta: {
            pathTitle: 'product_list',
            title: '产品配置'
        },
        component: () => import('@/views/product/productConfig.vue')
    },
    {
        path: 'product/channel',
        name: 'product_channel',
        meta: {
            pathTitle: 'channel_manage',
            title: '渠道列表'
        },
        component: () => import('@/views/product/channel.vue')
    },
    {
        path: 'product/charge',
        name: 'product_charge',
        meta: {
            pathTitle: 'channel_manage',
            title: '收费方案'
        },
        component: () => import('@/views/product/charge.vue')
    },
    {
        path: 'product/xjList',
        name: 'product_inquiry',
        meta: {
            pathTitle: 'product_inquiry',
            title: '询价产品列表'
        },
        component: () => import('@/views/product/xjList.vue')
    },
    {
        path: 'product/xjProductConfig',
        name: 'xjProductConfig',
        meta: {
            pathTitle: 'product_inquiry',
            title: '询价产品配置'
        },
        component: () => import('@/views/product/xjProductConfig.vue')
    },

]
export default general
